import { render } from "./Background.vue?vue&type=template&id=6d3c490e&ts=true"
import script from "./Background.vue?vue&type=script&lang=ts"
export * from "./Background.vue?vue&type=script&lang=ts"

import "./Background.vue?vue&type=style&index=0&id=6d3c490e&lang=css"

import exportComponent from "C:\\Users\\Vintz\\Documents\\Github\\SiteCV\\site-cv-main-page\\site-cv-main-page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__